(() => {
  if (customElements.get('epc-featured-spotlight')) return;

  const componentNames = [
    ['case', 'Case'], ['cooler', 'Cooler'], ['psu', 'Power supply'], ['kettle_lead', 'Power cable'],
    ['mobo', 'Motherboard'], ['cpu', 'Processor'], ['gpu', 'Graphics card'], ['ram', 'Memory'],
    ['sata_ssd', 'SATA SSD'], ['nvme_ssd', 'NVMe SSD'], ['sata_hdd', 'Hard drive'],
    ['windows_key', 'Operating system'], ['wifi', 'Wi-Fi'],
  ];
  const catalogCache = new Map();
  const cacheAge = 3 * 60 * 1000;
  const summaryUrl = document.currentScript?.dataset.summaryUrl;
  let summaryLoaded = false, summaryRequest;
  function loadSummarySeed() {
    if(!summaryRequest)summaryRequest=fetch(summaryUrl,{signal:AbortSignal.timeout(10000),priority:'low'}).then(response=>response.ok?response.json():null).then(data=>{
      if(data?.version===1 && data.cases && Array.isArray(data.componentGroups))publishedSummaries=data;
    }).catch(()=>{}).finally(()=>{summaryLoaded=true;});
    return summaryRequest;
  }
  // Published case defaults with exact-SKU photos and specifications. Refresh the
  // display data with maintenance/build-summary-details-20261011/generate.cjs.
  let publishedSummaries = /* CARD_SUMMARY_DATA_START */{"version":1,"cases":{},"componentGroups":[]}/* CARD_SUMMARY_DATA_END */;
  let summaryDialog;
  let summarySequence = 0;
  let summaryOpener;
  let previousOverflow = '';
  let retrySummary;
  let summaryPhotos = [];
  let photoDialog;
  let photoIndex = 0;
  let photoOpener;

  function fullProductImage(value) {
    const source = publicImage(value);
    if (!source) return '';
    const url = new URL(source);
    if (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')) {
      url.searchParams.set('width', '2000');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
    }
    return url.href;
  }

  function updateSummaryPhotos(values) {
    const seen = new Set();
    summaryPhotos = values.map(fullProductImage).filter(source => {
      if (!source) return false;
      const url = new URL(source);
      // Shopify serves the same file through both CDN and storefront aliases.
      const identity = url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')
        ? url.pathname.slice(url.pathname.lastIndexOf('/') + 1) : source;
      if (seen.has(identity)) return false;
      seen.add(identity);
      return true;
    });
    const button = summaryDialog.querySelector('[data-build-summary-photos]');
    button.hidden = !summaryPhotos.length;
    button.textContent = summaryPhotos.length > 1 ? `View all photos (${summaryPhotos.length})` : 'View full image';
    summaryDialog.querySelector('[data-build-summary-image-open]').disabled = !summaryPhotos.length;
    if (photoDialog?.open) {
      photoIndex = Math.min(photoIndex, summaryPhotos.length - 1);
      paintProductPhoto();
    }
  }

  function paintProductPhoto() {
    if (!photoDialog || !summaryPhotos.length) return;
    const title = summaryDialog.querySelector('[data-build-summary-product]').textContent;
    const image = photoDialog.querySelector('[data-product-photo]');
    image.src = summaryPhotos[photoIndex];
    image.alt = `${title} — photo ${photoIndex + 1}`;
    image.hidden = false;
    photoDialog.querySelector('[data-product-photo-error]').hidden = true;
    photoDialog.querySelector('[data-product-photo-title]').textContent = title;
    photoDialog.querySelector('[data-product-photo-count]').textContent = `Photo ${photoIndex + 1} of ${summaryPhotos.length}`;
    photoDialog.querySelectorAll('[data-product-photo-step]').forEach(button => { button.hidden = summaryPhotos.length < 2; });
    const thumbs = photoDialog.querySelector('[data-product-photo-thumbs]');
    const restoreThumbFocus = thumbs.contains(document.activeElement);
    thumbs.replaceChildren(...summaryPhotos.map((source, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `View photo ${index + 1}`);
      button.setAttribute('aria-pressed', String(index === photoIndex));
      const thumb = document.createElement('img');
      const thumbUrl = new URL(source);
      if (thumbUrl.searchParams.has('width')) thumbUrl.searchParams.set('width', '120');
      thumb.src = thumbUrl.href;
      thumb.alt = '';
      thumb.loading = 'lazy';
      button.append(thumb);
      button.addEventListener('click', () => { photoIndex = index; paintProductPhoto(); thumbs.children[index]?.focus({ preventScroll: true }); });
      return button;
    }));
    thumbs.hidden = summaryPhotos.length < 2;
    if (restoreThumbFocus) thumbs.children[photoIndex]?.focus({ preventScroll: true });
  }

  function openProductPhotos(opener) {
    if (!summaryPhotos.length) return;
    photoOpener = opener;
    if (!photoDialog) {
      photoDialog = document.createElement('dialog');
      photoDialog.className = 'epc-product-photos';
      photoDialog.setAttribute('aria-labelledby', 'epc-product-photos-title');
      photoDialog.innerHTML = `<header class="epc-product-photos__header"><div><h2 id="epc-product-photos-title">Product photos</h2><p data-product-photo-title></p></div><button type="button" data-product-photo-close aria-label="Close product photos" autofocus>×</button></header>
        <div class="epc-product-photos__stage"><button type="button" data-product-photo-step="-1" aria-label="Previous photo">‹</button><img data-product-photo alt=""><p data-product-photo-error role="status" hidden>This photo could not be loaded. Try another photo.</p><button type="button" data-product-photo-step="1" aria-label="Next photo">›</button></div>
        <footer class="epc-product-photos__footer"><p data-product-photo-count role="status" aria-live="polite"></p><div class="epc-product-photos__thumbs" data-product-photo-thumbs aria-label="Product photo thumbnails"></div><button type="button" data-product-photo-close>Back to build summary</button></footer>`;
      photoDialog.querySelectorAll('[data-product-photo-close]').forEach(button => button.addEventListener('click', () => photoDialog.close()));
      const step = direction => { photoIndex = (photoIndex + direction + summaryPhotos.length) % summaryPhotos.length; paintProductPhoto(); };
      photoDialog.querySelectorAll('[data-product-photo-step]').forEach(button => button.addEventListener('click', () => step(Number(button.dataset.productPhotoStep))));
      photoDialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); step(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      photoDialog.addEventListener('click', event => { if (event.target === photoDialog) photoDialog.close(); });
      photoDialog.addEventListener('close', () => { if (summaryDialog.open) photoOpener?.focus({ preventScroll: true }); });
      photoDialog.querySelector('[data-product-photo]').addEventListener('error', event => {
        event.target.hidden = true;
        photoDialog.querySelector('[data-product-photo-error]').hidden = false;
      });
      document.body.append(photoDialog);
    }
    photoIndex = 0;
    paintProductPhoto();
    photoDialog.showModal();
  }

  function caseSkuFor(card) {
    return card.dataset.caseSku || card.closest('[data-configurator-case-sku]')?.dataset.configuratorCaseSku || '';
  }

  function validCatalog(catalog, sku) {
    return catalog?.success === true && catalog.product?.caseSku === sku && Array.isArray(catalog.componentGroups);
  }

  function builderCatalog(sku) {
    try {
      const raw = sessionStorage.getItem(`elite-pc-catalog:v3:${encodeURIComponent(sku)}`);
      const entry = raw && raw.length < 2 * 1024 * 1024 ? JSON.parse(raw) : null;
      const age = Date.now() - entry?.savedAt;
      return age >= 0 && age < cacheAge && validCatalog(entry.catalog, sku) ? entry : null;
    } catch { return null; }
  }

  function readySummaryCatalog(card) {
    const sku = caseSkuFor(card);
    const published=window.ElitePCPrepared?.catalog(sku);if(published)return published;
    const saved = catalogCache.get(sku);
    if (saved?.catalog && Date.now() - saved.savedAt < cacheAge) return saved.catalog;
    const recent = builderCatalog(sku);
    if (recent) return recent.catalog;
    const seed = publishedSummaries?.version === 1 && Object.hasOwn(publishedSummaries.cases, sku) ? publishedSummaries.cases[sku] : null;
    return seed ? { success: true, product: { caseSku: sku }, ...seed, componentGroups: publishedSummaries.componentGroups } : null;
  }

  function loadSummaryCatalog(card) {
    const sku = caseSkuFor(card);
    if (!sku) return Promise.reject(new Error('Missing case'));
    const published=window.ElitePCPrepared?.catalog(sku);if(published)return Promise.resolve(published);
    const saved = catalogCache.get(sku);
    if (saved && Date.now() - saved.savedAt < cacheAge) return saved.promise;
    // Reuse the product builder's recent public catalogue when available.
    const recent = builderCatalog(sku);
    if (recent) {
      const promise = Promise.resolve(recent.catalog);
      catalogCache.set(sku, { savedAt: recent.savedAt, promise, catalog: recent.catalog });
      return promise;
    }
    if(summaryUrl && !summaryLoaded)return loadSummarySeed().then(()=>loadSummaryCatalog(card));
    const prepared=readySummaryCatalog(card);
    if(prepared)return Promise.resolve(prepared);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    const entry = { savedAt: Date.now(), promise: null };
    entry.promise = fetch(`/apps/pc-configurator?action=catalog&caseSku=${encodeURIComponent(sku)}&release=live-components-v2`, {
      headers: { Accept: 'application/json' }, signal: controller.signal,
    }).then(async response => {
      const catalog = await response.json();
      if (!response.ok || !validCatalog(catalog, sku)) throw new Error('Could not read this build');
      entry.savedAt = Date.now();
      entry.catalog = catalog;
      return catalog;
    }).catch(error => {
      if (catalogCache.get(sku) === entry) catalogCache.delete(sku);
      throw error;
    }).finally(() => clearTimeout(timeout));
    catalogCache.set(sku, entry);
    if (catalogCache.size > 16) catalogCache.delete(catalogCache.keys().next().value);
    return entry.promise;
  }

  function componentLabel(key, option) {
    const recorded = publishedSummaries.componentGroups.find(group => group.key === key)?.options.find(item => item.sku === option.sku);
    if (option.summaryLabel || recorded?.summaryLabel) return option.summaryLabel || recorded.summaryLabel;
    let label = String(option.label || option.sku).trim();
    if (['ram', 'psu'].includes(key) && /^\d+(?:,\d{3})*(?:\.\d+)?$/.test(label)) label += key === 'ram' ? 'GB' : 'W';
    if (key === 'sata_ssd' && !/\bSATA\b/i.test(label)) label += ' SATA';
    if (key === 'nvme_ssd') {
      const specs = (option.displaySpecs || []).map(spec => `${spec.label} ${spec.value}`).join(' ');
      const generation = `${label} ${specs}`.match(/\bPCI(?:e|[ -]?e|\s*Express)\s*(?:Gen(?:eration)?\s*)?([1-9])(?:\.0)?(?:\b|(?=x))/i)?.[1];
      if (!/\bNVMe\b/i.test(label)) label += ' NVMe';
      if (generation && !/\bPCI(?:e|[ -]?e|\s*Express)/i.test(label)) label += ` PCIe ${generation}.0`;
    }
    return label;
  }

  function componentPresentation(key, option) {
    if (!option) return { details: '', image: '' };
    const recorded = publishedSummaries.componentGroups.find(group => group.key === key)?.options.find(item => item.sku === option.sku);
    const source = publicImage(option.images?.[0] || option.imageUrl || recorded?.imageUrl || '');
    let image = source;
    if (source) {
      const url = new URL(source);
      if (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')) url.searchParams.set('width', '112');
      image = url.href;
    }
    return { details: option.summaryDetails || recorded?.summaryDetails || '', image };
  }

  function publicImage(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch { return ''; }
  }

  function createSummaryDialog() {
    if (summaryDialog) return summaryDialog;
    const dialog = document.createElement('dialog');
    dialog.id = 'epc-build-summary';
    dialog.className = 'epc-build-summary';
    dialog.setAttribute('aria-labelledby', 'epc-build-summary-title');
    dialog.innerHTML = `
      <header class="epc-build-summary__header">
        <div><p class="epc-build-summary__eyebrow">Your configuration</p><h2 id="epc-build-summary-title">PC build summary</h2></div>
        <button type="button" class="epc-build-summary__close" aria-label="Close build summary" data-build-summary-close autofocus><svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="m6 6 12 12M18 6 6 18"/></svg></button>
      </header>
      <div class="epc-build-summary__body">
        <div class="epc-build-summary__product"><button type="button" class="epc-build-summary__image-open" data-build-summary-image-open aria-label="View full-size product photos"><img alt="" data-build-summary-image width="112" height="112"></button><div><h3 data-build-summary-product></h3><p>Your selected components, ready to customise.</p><button type="button" class="epc-build-summary__photos" data-build-summary-photos>View all photos</button></div></div>
        <h4 class="epc-build-summary__label">Selected components</h4>
        <div class="epc-build-summary__status" role="status" data-build-summary-status></div>
        <dl class="epc-build-summary__components" data-build-summary-components></dl>
        <button type="button" class="epc-build-summary__retry" data-build-summary-retry hidden>Try again</button>
      </div>
      <footer class="epc-build-summary__footer"><button type="button" class="epc-build-summary__back" data-build-summary-close>Keep browsing</button><a class="epc-build-summary__configure" data-build-summary-configure>Configure PC <span aria-hidden="true">→</span></a></footer>`;
    dialog.querySelectorAll('[data-build-summary-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.querySelector('[data-build-summary-retry]').addEventListener('click', () => retrySummary?.());
    dialog.querySelectorAll('[data-build-summary-image-open], [data-build-summary-photos]').forEach(button => button.addEventListener('click', () => openProductPhotos(button)));
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      summarySequence++;
      if (photoDialog?.open) photoDialog.close();
      document.documentElement.style.overflow = previousOverflow;
      summaryOpener?.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-build-summary-image]').addEventListener('error', event => { event.target.hidden = true; });
    document.body.append(dialog);
    summaryDialog = dialog;
    return dialog;
  }

  function showBuildSummary(card, opener) {
    const url = new URL(opener.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return false;
    const requestedParts = new URLSearchParams(url.search);
    const completeBuild = /^gaming-pc(?:-home)?$/.test(requestedParts.get('pc') || '');
    const dialog = createSummaryDialog();
    const sequence = ++summarySequence;
    summaryOpener = opener;
    retrySummary = () => showBuildSummary(card, opener);
    const list = dialog.querySelector('[data-build-summary-components]');
    const status = dialog.querySelector('[data-build-summary-status]');
    const retry = dialog.querySelector('[data-build-summary-retry]');
    const configure = dialog.querySelector('[data-build-summary-configure]');
    const image = dialog.querySelector('[data-build-summary-image]');
    dialog.querySelector('[data-build-summary-product]').textContent = card.dataset.productTitle;
    configure.href = url.href;
    const photo = card.querySelector('[data-spotlight-slide]:not([hidden]) img');
    const imageUrl = publicImage(photo?.currentSrc || photo?.src || '');
    image.hidden = !imageUrl;
    if (imageUrl) image.src = imageUrl;
    image.alt = card.dataset.productTitle || '';
    const cardPhotos = Array.from(card.querySelectorAll('[data-spotlight-slide] img')).map(photo => photo.dataset.eliteGallerySrc || photo.currentSrc || photo.src);
    updateSummaryPhotos(cardPhotos);
    retry.hidden = true;
    list.replaceChildren();
    list.setAttribute('aria-busy', 'true');
    status.textContent = 'Getting your selected components…';
    const renderCatalog = catalog => {
      const groups = new Map(catalog.componentGroups.filter(group => group.visible !== false && group.sendToShopify !== false).map(group => [group.key, group]));
      const required = new Set(['case', 'mobo', 'cpu', 'gpu', 'ram', 'psu', ...(catalog.requiredComponents || [])]);
      const chosen = [];
      for (const [key, label] of componentNames) {
        const options = groups.get(key)?.options || [];
        const requested = requestedParts.get(`elite_${key}`) || requestedParts.get(`component_${key}`);
        const selectedSku = key === 'case' ? caseSkuFor(card)
          : options.some(option => option.sku === requested) ? requested : completeBuild ? '' : catalog.defaultSelections?.[key];
        const option = options.find(option => option.sku === selectedSku);
        if (key !== 'case') {
          // Pass exactly the real parts shown here into the builder; obsolete
          // homepage placeholder SKUs are not presented as selected products.
          url.searchParams.delete(`elite_${key}`);
          url.searchParams.delete(`component_${key}`);
          if (option) url.searchParams.set(`elite_${key}`, option.sku);
        }
        const { details, image: componentImage } = componentPresentation(key, option);
        const description = option ? componentLabel(key, option) : key === 'case' ? card.dataset.productTitle
          : completeBuild ? 'None selected' : required.has(key) ? 'Choose in configurator' : 'None selected';
        const thumbnailUrl = componentImage || (key === 'case' ? imageUrl : '');
        const signature = JSON.stringify([description, details, thumbnailUrl]);
        if (key === 'case' && option) {
          const actualImage = publicImage(option.images?.[0] || option.imageUrl || '');
          if (actualImage) { image.src = actualImage; image.hidden = false; }
          updateSummaryPhotos([...(option.images || []), option.imageUrl, ...cardPhotos]);
        }
        let row = list.querySelector(`[data-summary-component="${key}"]`);
        if (row?.dataset.summarySignature === signature) {
          chosen.push(row);
          continue;
        }
        row = document.createElement('div');
        row.dataset.summaryComponent = key;
        row.dataset.summarySignature = signature;
        const term = document.createElement('dt');
        term.textContent = label;
        const value = document.createElement('dd');
        const thumbnail = document.createElement('span');
        thumbnail.className = 'epc-build-summary__component-photo';
        thumbnail.setAttribute('aria-hidden', 'true');
        const fallback = document.createElement('span');
        fallback.textContent = option ? 'No photo' : '—';
        thumbnail.append(fallback);
        if (thumbnailUrl) {
          const photo = document.createElement('img');
          photo.width = 56;
          photo.height = 56;
          photo.alt = '';
          photo.src = thumbnailUrl;
          photo.addEventListener('error', () => { photo.hidden = true; fallback.hidden = false; });
          fallback.hidden = true;
          thumbnail.append(photo);
        }
        const name = document.createElement('span');
        name.className = 'epc-build-summary__component-name';
        name.textContent = description;
        value.append(thumbnail, name);
        if (details) {
          const detail = document.createElement('span');
          detail.className = 'epc-build-summary__component-details';
          detail.textContent = details;
          value.append(detail);
        }
        row.append(term, value);
        chosen.push(row);
      }
      // Keep loaded photos in place when the background catalogue agrees with
      // the embedded data; a refresh must not flash or move unchanged rows.
      if (chosen.some((row, index) => list.children[index] !== row) || list.children.length !== chosen.length) list.replaceChildren(...chosen);
      list.setAttribute('aria-busy', 'false');
      status.textContent = '';
      configure.href = url.href;
    };
    const instantCatalog = readySummaryCatalog(card);
    if (instantCatalog) renderCatalog(instantCatalog);
    if (!dialog.open) {
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    // A fresh catalogue can update the already-visible summary in the background.
    // It never clears the published parts or gates the Configure PC link.
    loadSummaryCatalog(card).then(catalog => {
      if (sequence !== summarySequence || !dialog.open) return;
      renderCatalog(catalog);
    }).catch(() => {
      if (sequence !== summarySequence || !dialog.open) return;
      if (instantCatalog) return;
      list.setAttribute('aria-busy', 'false');
      status.textContent = 'The component summary could not be opened. Try again or continue to the configurator.';
      retry.hidden = false;
    });
    return true;
  }


  // All cards use page-rendered retail totals and link to those exact parts.
  // Stock and fit are checked by the configurator before a purchase.
  function prepareHomePrice(card) {
    if (card.hasAttribute('data-home-pc-pricing')) window.ElitePCPagePrice?.paintCard(card);
  }

  function prepareGalleryPhoto(slide) {
    const image = slide.querySelector('img[data-elite-gallery-src]');
    if (!image || image.hasAttribute('src')) return;
    const url = new URL(image.dataset.eliteGallerySrc, location.href);
    const sizes = image.dataset.eliteGallerySizes;
    const srcset = [200, 240, 320, 360, 420, 600, 640, 800, 1000].map(width => {
      const candidate = new URL(url); candidate.searchParams.set('width', String(width));
      return `${candidate.href} ${width}w`;
    }).join(', ');
    // Preserve the contained mobile photo size and native automatic sizing
    // when a customer changes between desktop grid and list views.
    const picture = document.createElement('picture'); picture.style.display = 'contents';
    const source = document.createElement('source'); source.media = '(max-width: 749px)';
    source.sizes = sizes.replace(/^auto,\s*/, ''); source.srcset = srcset;
    image.replaceWith(picture); picture.append(source, image);
    image.sizes = sizes; image.srcset = srcset; image.src = url.href;
  }

  customElements.define('epc-featured-spotlight', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      prepareHomePrice(this);
      this.slides = Array.from(this.querySelectorAll('[data-spotlight-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-spotlight-index]'));
      this.index = 0;
      // Filtering and pagination can clone a card that was showing another slide.
      this.showSlide(0);

      this.querySelectorAll('[data-spotlight-step], [data-spotlight-controls]').forEach(control => {
        control.hidden = false;
      });
      this.addEventListener('click', event => {
        const details = event.target.closest('.epc-spotlight__button--details');
        if (details && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          if (showBuildSummary(this, details)) event.preventDefault();
          return;
        }
        const control = event.target.closest('button');
        if (!control || !this.contains(control)) return;
        if (control.hasAttribute('data-spotlight-step')) {
          this.showSlide(this.index + Number(control.dataset.spotlightStep));
        } else if (control.hasAttribute('data-spotlight-index')) {
          this.showSlide(Number(control.dataset.spotlightIndex));
        }
      });
      const prepareSummary = event => {
        if (event.target.closest('.epc-spotlight__button--details')) void loadSummaryCatalog(this).catch(() => {});
      };
      this.addEventListener('pointerover', prepareSummary);
      this.addEventListener('focusin', prepareSummary);
      this.querySelector('[data-spotlight-gallery]').addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.showSlide(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }

    showSlide(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      prepareGalleryPhoto(this.slides[this.index]);
      this.slides.forEach((slide, position) => {
        slide.hidden = position !== this.index;
      });
      this.dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === this.index)));
      const status = this.querySelector('[data-spotlight-gallery-status]');
      if (status) status.textContent = `Image ${this.index + 1} of ${this.slides.length}`;
    }

  });
})();
